import { render, staticRenderFns } from "./PauseQuestion.vue?vue&type=template&id=1c079652&scoped=true&"
import script from "./PauseQuestion.vue?vue&type=script&lang=js&"
export * from "./PauseQuestion.vue?vue&type=script&lang=js&"
import style0 from "./PauseQuestion.vue?vue&type=style&index=0&id=1c079652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c079652",
  null
  
)

export default component.exports